import React from 'react'
import {
  LocationProvider,
  createHistory,
  createMemorySource,
} from '@gatsbyjs/reach-router'

// En el browser NO se envuelve nada: Gatsby ya monta su propio <Location> por
// fuera de wrapRootElement en producción, así que cualquier provider extra
// sobrescribe el LocationContext bueno y congela useLocation() en la URL de
// entrada durante toda la sesión SPA.
// En SSR sí se mantiene, con memory source, como red de seguridad para lo que
// se renderice por encima de <ServerLocation>.
const withLocationProvider = (element, pathname = '/') => {
  if (typeof window !== 'undefined') return element

  return (
    <LocationProvider history={createHistory(createMemorySource(pathname || '/'))}>
      {element}
    </LocationProvider>
  )
}

export default withLocationProvider
